import { ApiRequestBody, ApiRequestParams, ApiResponse, ApiResponseError } from '../types';

export const getOrigin = (url: string) => {
    const baseUrl = url.match(/(https?:\/\/.*?)(\/|$)/);

    return baseUrl ? baseUrl[1] : url;
};

export const addSearchParams = (url: string, params: Record<string, string> = {}) => {
    const searchParams = new URLSearchParams(params);

    if (!searchParams.size) {
        return url;
    }

    const urlObject = new URL(url);

    for (let [key, value] of searchParams.entries()) {
        if (!value) continue;
        urlObject.searchParams.set(key, value);
    }

    return urlObject.href;
};

export const encodeRequest = (data: ApiRequestBody) =>
    Object.keys(data)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key]!)}`)
        .join('&');

export const decodeResponse = <T>(body: string) => {
    try {
        const data: ApiResponse<T> = JSON.parse(body);

        if (data && data.status) {
            return data;
        }

        return {
            status: 'error',
            description: 'Unknown response',
        } as ApiResponseError;
    } catch (_err) {
        return {
            status: 'error',
            description: 'Error response decoding',
        } as ApiResponseError;
    }
};

export const encodeParams = (params: ApiRequestParams) => {
    return Object.keys(params).reduce<string[]>((res, key) => {
        const value = params[key];

        if (value !== null && value !== undefined) {
            res.push(`${key}=${encodeURIComponent(value)}`);
        }

        return res;
    }, []);
};

export const buildUrl = (url: string, params: ApiRequestParams = {}) => {
    const encodedParams = encodeParams(params);

    if (encodedParams.length) {
        return `${url}?${encodedParams.join('&')}`;
    }

    return url;
};
